import React from "react";
import {connect} from "react-redux";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";
import {ReduxWebcastStatusType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastStatus";
import {useTranslation} from "react-i18next";
import {
    ReduxWebcastCurrentRoundBiddingType
} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {RoundTypeEnum} from "@nextlot/core/webcast";
import {ROUND_TYPES_DISPLAY_NAMES_MAP} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {CurrencyAmountDisplay} from "../CurrencyAmountDisplay";
import EmbeddedViewerLotDetailsCmp from "./ViewerEmbeddedLotDetailsCmp";

type CmpProps = {
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
    lotsMapById: Map<number, Lot>
}

function EmbeddedViewerCurrentRoundCmp(props: CmpProps) {

    const { t, i18n } = useTranslation();
    const {currentRound, lotsMapById} = props;
    const {askingBidValue, highestBid} = props.currentRoundBidding;

    const firstLot:Lot = lotsMapById.get(currentRound.lotsIds[0]);

    return (
        <>
            <div className="bidder-current-round-outline">
                <div className="bidder-cmp bidder-cmp--current-round">
                    <div className="cmp__header">
                        <h5 className="m-0">
                            {(currentRound.roundType === RoundTypeEnum.SINGLE_NORMAL || currentRound.roundType === RoundTypeEnum.SINGLE_BOXLOT) ?
                                'Lot'
                                :
                                ROUND_TYPES_DISPLAY_NAMES_MAP.get(currentRound.roundType)
                            }
                            {(currentRound.lotsIds.length > 1) && <span className="pt-1"> (<strong>{currentRound.lotsIds.length} {t('common.lots')}</strong>)</span>}
                            :
                            {currentRound.lotsIds.map(lotId => ` #${lotsMapById.get(lotId).number}`).join(", ")}
                        </h5>

                    </div>
                    <div className="cmp__body d-flex flex-column justify-content-between">
                        <div className="bid-details">
                            {highestBid ?
                                <p className="viewer-embedded-highest-bid"><strong><CurrencyAmountDisplay valueCents={highestBid.value}/></strong> <i>from</i> {highestBid.bidderDisplay}</p>
                                : ''
                            }

                            {askingBidValue > 0 ?
                                <p className="viewer-embedded-asking-bid mb-0"><i>Asking</i>: <CurrencyAmountDisplay valueCents={askingBidValue}/></p>
                                :
                                <p className="waiting">Waiting for bidding to start</p>
                            }
                        </div>

                        <EmbeddedViewerLotDetailsCmp
                            lot={firstLot}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}


export default connect(({activeWebcast}) => {
    return {
        currentRound: activeWebcast.webcastCurrentRound,
        currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
        lotsMapById: activeWebcast.webcastAuctionData.lotsMapById,
    };
})(EmbeddedViewerCurrentRoundCmp);



// import * as React from "react";
// import {connect} from "react-redux";
// import type {Lot} from "@nextlot/bidding-jsclient-core/lib/data/data_types_definitions";
// import type {ReduxWebcastCurrentRoundType} from "@nextlot/bidding-jsclient-core/lib/redux/webcast/reducerWebcastCurrentRound";
// import {ROUND_TYPES_DISPLAY_NAMES_MAP, RoundTypeEnum} from "@nextlot/bidding-jsclient-core/lib/data/WebcastDataDomain";
// import {useTranslation} from "react-i18next";
// import EmbeddedViewerLotDetailsCmp from "./ViewerEmbeddedLotDetailsCmp";
// import {CurrencyAmountDisplay} from "../CurrencyAmountDisplay";
//
//
// type CmpProps = {
//     currentRound: ReduxWebcastCurrentRoundType,
//     lotsMapById: Map<number, Lot>
// }
//
//
// function EmbeddedViewerCurrentRoundCmp(props: CmpProps) {
//     const {t} = useTranslation();
//     const {currentRound, lotsMapById} = props;
//     const {askingBidValue, highestBid} = props.currentRoundBidding;
//
//     const firstLot = lotsMapById.get(currentRound.lotsIds[0]);
//
//     return (
//         <div className="bidder-current-round-outline">
//             <div className="bidder-cmp bidder-cmp--current-round">
//                 <div className="cmp__header">
//                     <h5 className="m-0">
//                         {   (currentRound.roundType === RoundTypeEnum.SINGLE_NORMAL ||
//                             currentRound.roundType === RoundTypeEnum.SINGLE_BOXLOT) ?
//                             'Lot'
//                             :
//                             ROUND_TYPES_DISPLAY_NAMES_MAP.get(currentRound.roundType)
//                         }
//                         {(currentRound.lotsIds.length > 1) &&
//                         <span
//                             className="pt-1"> (<strong>{currentRound.lotsIds.length} {t('common.lots')}</strong>)</span>
//                         }
//                         :
//                         {currentRound.lotsIds.map(lotId => ` #${lotsMapById.get(lotId).number}`).join(", ")}
//                     </h5>
//
//                 </div>
//                 <div className="cmp__body d-flex flex-column justify-content-between">
//                     <div className="bid-details">
//                         {highestBid ?
//                             <p className="viewer-embedded-highest-bid"><strong><CurrencyAmountDisplay
//                                 valueCents={highestBid.value}/></strong> <i>from</i> {highestBid.bidderDisplay}</p>
//                             : ''
//                         }
//
//                         {askingBidValue > 0 ?
//                             <p className="viewer-embedded-asking-bid mb-0"><i>Asking</i>: <CurrencyAmountDisplay
//                                 valueCents={askingBidValue}/></p>
//                             :
//                             <p className="waiting">Waiting for bidding to start</p>
//                         }
//                     </div>
//
//                     <EmbeddedViewerLotDetailsCmp
//                         lot={firstLot}
//                     />
//                 </div>
//             </div>
//         </div>
//     )
// }
//
// export default connect(({activeWebcast}) => {
//     return {
//         currentRound: activeWebcast.webcastCurrentRound,
//         currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
//         lotsMapById: activeWebcast.webcastAuctionData.lotsMapById,
//     };
// })(EmbeddedViewerCurrentRoundCmp);

